

const SkillCard = (props) => {

    const {name, imageLink, alt} = props.skill;

    // console.log(name, imageLink, alt);
    
    
  return (
    <div className="skillCard m-2 p-2 h-20 flex gap-1 justify-start items-center transition ease-in-out delay-75 hover:-translate-y-1 hover:scale-95 duration-75">
      <div className="icon">
        <img
         className="w-10"
          // src= {(imageLink==="")?VERCEL:imageLink}
          // alt={alt}
          src={imageLink}
        />
      </div>
      <div className="name text-2xl">{name}</div>
    </div>
  );
};

export default SkillCard;
